import IconCheck from "@src/assets/icons/tabler/check.svg?react";
import IconCopy from "@src/assets/icons/tabler/copy.svg?react";

interface ReferralInvitationLinkProps {
	invitationLink: string;
	isLinkCopied: boolean;
	onCopyLink: () => void;
}

export function ReferralInvitationLink({
	invitationLink,
	isLinkCopied,
	onCopyLink,
}: ReferralInvitationLinkProps) {
	return (
		<div className="flex flex-col gap-4">
			<div>
				<p className="mb-1 uppercase tracking-wider text-text-muted text-xs font-bold">
					Your Invitation Link
				</p>
				<p className="sm:text-sm text-text-secondary text-xs">
					Share your link — you'll get your reward once friends claimed their
					free month.
				</p>
			</div>

			<div className="flex items-center gap-2 p-1 pl-3 bg-surface-subtle border border-border-default rounded-xl">
				<p className="flex-1 truncate text-text-secondary font-mono opacity-70 text-xs">
					{invitationLink}
				</p>
				<div className="flex items-center gap-2">
					<button
						type="button"
						onClick={onCopyLink}
						className="p-1.5 hover:bg-surface-hover-subtle rounded-lg transition-colors sm:p-2"
						title="Copy link"
					>
						{isLinkCopied ? (
							<IconCheck width={16} height={16} className="text-green-500" />
						) : (
							<IconCopy
								width={16}
								height={16}
								className="text-text-secondary"
							/>
						)}
					</button>
				</div>
			</div>
		</div>
	);
}
